import { createNamespacedHelpers } from 'vuex'
import { E_PROMOTION_TYPE } from '@/config'
import { isEmptyObject, isNullOrEmpty } from '@/utils'

import * as config from './product.config'

import PROUDCT_TYPE from '@/router/home/components/product/product-intro/config'

export const setTitle = vueInstance => {
  vueInstance.$$title(config.PAGE_TITLE)
}

export const mainName = location.hostname.replace(
  /^.*?(\..*)/,
  function replace(a, b) {
    return b
  }
)

// 用户提交订单时候的参数
export const setLiveCookie = vueInstance => {
  const { liveid, livestore } = vueInstance.$route.query || {}
  vueInstance.$$cookie.set('liveid', liveid || '', { domain: mainName })
  vueInstance.$$cookie.set('livestore', livestore || '', {
    domain: mainName
  })
}

export const getProductDetail = vueInstance => {
  const { spuId = '' } = vueInstance.$route.params
  const {
    skuId = '',
    ruleType = 1,
    ruleId = '',
    empId = ''
  } = vueInstance.$route.query
  //
}

export const getComment = async vueInstance => {
  const commntJson = await vueInstance.$store.dispatch('getNewCommentList', {
    page: 1,
    size: 2,
    objectId: vueInstance.spuId,
    type: 9,
    uid: vueInstance.$$cookie('uid'),
    skey: vueInstance.$$cookie('skey'),
    property: 2 // 短评
  })
  if (+commntJson.code === 1) {
    const { data = {} } = commntJson
    return data
    // commentData = commntJson.data || {};
    // if (commentData && commentData.total > 0) {
    //   if (titles.findIndex((item) => item.id === 'commentId') < 0) {
    //     titles.push({ title: '评价', id: 'commentId' });
    //   }
    // }
  } else {
    vueInstance.$$toast({
      message: commntJson.msg
    })
  }
}

export const getProductExp = product => {
  const lb = []
  if (product.isAnyTimeRefund === 0 && product.isExpiredRefund === 0) {
    lb.push({ title: '不可退', isGood: 0 })
  } else {
    if (product.isAnyTimeRefund === 1) {
      lb.push({ title: '随时退', isGood: 1 })
    }
    if (product.isExpiredRefund === 1) {
      lb.push({ title: '过期退', isGood: 1 })
    }
  }
  // if (product.isSchedule * 1 === 1) {
  //   lb.push({title: '需预约', isGood: 1})
  // } else {
  //   lb.push({title: '免预约', isGood: 1})
  // }

  if (product.isPosPay * 1 === 1) {
    lb.push({ title: 'POS支付', isGood: 1 })
  }
  if (+product.spuType === PROUDCT_TYPE.YU_ER)
    lb.push({ title: 'PICC承保', isGood: 1 })
  return lb
}

// 购买按钮是否可用
export const buyButtonEnable = (product, selectedSku) => {
  if (product.status === 4) {
    if (selectedSku.skuId) {
      if (selectedSku.availableInventory > 0) {
        return true
      } else {
        return false
      }
    }
    return true
  }
}

// 是否卖完
export const isSoldOut = selectedSku => {
  if (selectedSku && selectedSku.skuId) {
    if (selectedSku.availableInventory > 9992) {
      return false
    } else {
      return true
    }
  }
}

export const getBtnValue = (product, selectedSku) => {
  // buyButtonEnable()
  let t = {}
  if (buyButtonEnable(product, selectedSku)) {
    t.textValue = '购买'
    t.className = 'btn-pink'
  } else {
    t.className = 'btn-grey'
    if (isSoldOut(selectedSku)) {
      t.textValue = '已售罄'
    } else {
      t.textValue = '暂不提供服务'
    }
  }
  return t
}

export const getData = (promotionInfo = {}) => {
  const { mixPromList = [] } = promotionInfo
  const { couponDto = {}, minPrice = 0, promList = [] } = mixPromList[0]
  const { type = '' } = promList[0]
  return { couponDto, minPrice, promList, type }
}

//
export const isSeckill = () => {
  const { couponDto, type } = getData()
  return isEmptyObject(couponDto) && type === E_PROMOTION_TYPE.FLASH_SALE
}
// 包含秒杀的混合优惠
export const mixDiscountWithSeckil = () => {
  const { couponDto, type } = getData()
  return !isEmptyObject(couponDto) && type === E_PROMOTION_TYPE.FLASH_SALE
}
// 不包含秒杀的混合优惠
export const mixDiscountWithoutSeckil = () => {
  const { couponDto, type } = getData()
  return isEmptyObject(couponDto) && type !== E_PROMOTION_TYPE.FLASH_SALE
}

// 立减------券为空&type为立减
export const isDirectReduce = () => {
  const { couponDto, type } = getData()
  return isEmptyObject(couponDto) && type === E_PROMOTION_TYPE.DISCOUNT
}

export const isStoreCoupon = () => {
  const { couponDto, promList } = getData()
  return !isEmptyObject(couponDto) && promList.length === 1
}

export const isPlatCoupon = () => {
  const { couponDto, promList } = getData()
  return !isEmptyObject(couponDto) && promList.length === 1
}

/**
 * 设置营销重构模块信息
 * @param {Vue} vueInstance
 */
export async function dispatchMixPromotion(vueInstance) {
  const {
    skuId,
    spuId,
    businessId,
    level4CategoryId,
    skuList = [],
    skuIdForMixPromInfo
  } = vueInstance
  const { mapActions, mapMutations } = createNamespacedHelpers('promotionInfo')
  const { dispatchPromotionInfo } = mapActions(['dispatchPromotionInfo'])
  const { setSKUList } = mapMutations(['setSKUList'])
  setSKUList.call(vueInstance, skuList)

  await dispatchPromotionInfo.call(vueInstance, {
    params: {
      skuId: skuId || skuIdForMixPromInfo,
      spuId,
      businessId,
      level4CategoryId
    },
    vueInstance
  })
}

/**
 * 判断商详页是否为秒杀活动页面
 * 判断订单确认页是否来自秒杀商详
 * @param {import('vue-router').Route} route
 */
export function isFlashSalePage(route) {
  const { ruleType = -1, ruleId } = route.query
  const t = +ruleType
  return t === E_PROMOTION_TYPE.FLASH_SALE && !isNullOrEmpty(ruleId)
}
